import { DOMRouteHandler } from '../util/Router';
import { notifyHandledException } from '../util/error-handling';

export class PageTemplateTempMarketplace extends DOMRouteHandler {
  static init(): void {
    import('../modules/marketplace').then((module) => module.initFiltersHandler()).catch(notifyHandledException);
  }
}
